<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import permissionVerificationMinxins from '@/mixins/permission-verification.js'
export default {
  mixins: [permissionVerificationMinxins]
}
</script>

<style>

</style>